export const MEETING_ROOM_FEATURE_FLAG = 'meet.meetingRoom'

export const isMeetingRoomKind = (value: string | undefined): boolean =>
  value === 'lc_meet' || value === 'lc_meet_conference'

export const shouldShowMeetingRoomOption = (
  enabled: boolean,
  selectedValues: Iterable<string | undefined> = []
): boolean => {
  if (enabled) {
    return true
  }
  for (const value of selectedValues) {
    if (isMeetingRoomKind(value)) {
      return true
    }
  }
  return false
}

export const filterMeetingRoomOptions = <T extends { value: string }>(
  options: T[],
  enabled: boolean,
  selectedValues: Iterable<string | undefined> = []
): T[] => {
  if (shouldShowMeetingRoomOption(enabled, selectedValues)) {
    return options
  }
  return options.filter(option => !isMeetingRoomKind(option.value))
}
